import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'

import { KVMessageDef } from './index'

export function getCameraPoseClickedMessage(): KVMessageDef {
  return {
    type: 'cameraPoseClicked',
    requiredData: ['imageName'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      // Find the photo with the matching filename and set it as selected
      const imageName = json.imageName as string

      // First try to find in filteredPhotos (has projection data for crosshair)
      let photo = kv.filteredPhotos?.find((p) => p.filename === imageName)

      // Fall back to photos array if not in filtered
      if (!photo) {
        photo = kv.photos.find((p) => p.filename === imageName)
      }

      if (!photo) return

      // Always update the selected photo
      kv.setSelectedPhoto(photo)

      // If docked panel is open, don't open the floating reel - just update selection
      if (kv.photoReelDocked) {
        return
      }

      // If floating reel isn't open, open it
      if (!kv.photoReelOpen) {
        kv.setPhotoReelOpen(true)
      }
    },
  }
}
